var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73319 8.2334C8.48757 8.46227 8.29056 8.73827 8.15392 9.04494C8.01729 9.3516 7.94381 9.68265 7.93789 10.0183C7.93197 10.354 7.99372 10.6874 8.11945 10.9987C8.24519 11.31 8.43234 11.5928 8.66973 11.8302C8.90713 12.0676 9.18991 12.2547 9.5012 12.3805C9.8125 12.5062 10.1459 12.568 10.4816 12.562C10.8173 12.5561 11.1483 12.4826 11.455 12.346C11.7617 12.2094 12.0377 12.0124 12.2665 11.7667",
    stroke: "#2A2A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44141 4.23341C9.7925 4.18967 10.1459 4.16741 10.4997 4.16675C16.3331 4.16675 18.8331 10.0001 18.8331 10.0001C18.4605 10.7977 17.9933 11.5475 17.4414 12.2334",
    stroke: "#2A2A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00964 5.5083C4.35234 6.63715 3.0262 8.18768 2.16797 9.99997C2.16797 9.99997 4.66797 15.8333 10.5013 15.8333C12.0979 15.8376 13.6603 15.3709 14.993 14.4916",
    stroke: "#2A2A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16797 1.66675L18.8346 18.3334",
    stroke: "#2A2A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.4809ee79168b24c867725e48ca1c6d49.svg";
export { ForwardRef as ReactComponent };